export default {
  modelName: 'idtf_review_overall',
  versionModelName: 'act_version',
  label: '我的總覆核鑑別作業',
};
